import { useState } from "react";
import PageHeader from "@/components/base/PageHeader";
import { useNavigate } from "react-router-dom";

export default function Notifications() {
  const [settings, setSettings] = useState({
    reportReminder: true,
    riskAlert: true,
  });

  const items = [
    // 交易提醒（短信通知）暂时隐藏
    // { key: "tradeReminder" as const, label: "交易提醒", description: ... },
    { key: "reportReminder" as const, label: "报表提醒", description: "每日/每周收益报表生成时通知" },
    { key: "riskAlert" as const, label: "风险告警", description: "止盈止损触发和重大回撤警告" },
  ];

  return (
    <div className="pb-[80px]">
      <PageHeader title="通知设置" backTo="/profile" />

      <div className="px-4">
        <div className="bg-white rounded-2xl overflow-hidden divide-y divide-background-100">
                {items.map((item) => (
                  <div key={item.key} className="flex items-center justify-between px-4 py-4">
                    <div className="flex-1 min-w-0 mr-3">
                      <p className="text-sm font-medium text-foreground-950">
                        {item.label}
                      </p>
                      <p className="text-xs mt-0.5 text-foreground-400">
                        {item.description}
                      </p>
                    </div>
                    <div className={`w-12 h-7 rounded-full bg-background-300 relative flex-shrink-0 ${
                      settings[item.key] ? "" : "opacity-40"
                    }`}>
                      <div className="w-5 h-5 rounded-full bg-white absolute top-1 left-6" />
                    </div>
                  </div>
                ))}
          </div>

      </div>
    </div>
  );
}
